import React from "react";
import { v4 as uuidv4 } from "uuid";

interface Props {
  title?: string;
  subTitle?: string;
  inputType?: string;
  className?: string;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  defaultValue?: string;
  onChange: (value: any) => void;
  error?: boolean;
  autoFocus?: boolean;
}

export default function UncontrolledInputField({
  title,
  subTitle,
  inputType = "text",
  className,
  value,
  defaultValue,
  placeholder,
  disabled,
  onChange,
  error,
  autoFocus = false,
}: Props) {
  const formInputId = React.useMemo(() => {
    return uuidv4();
  }, []);

  return (
    <>
      {!!title && (
        <label htmlFor={formInputId} className="block text-sm font-medium leading-5 text-gray-700">
          {title}
          {error ? <span className="text-red-500 "> required</span> : null}
        </label>
      )}
      {!!subTitle && (
        <label htmlFor={formInputId} className="block text-sm leading-5 text-gray-500">
          {subTitle}
        </label>
      )}
      <input
        placeholder={placeholder}
        type={inputType}
        id={formInputId}
        disabled={disabled}
        defaultValue={defaultValue}
        onChange={(event) => (event.target.value ? onChange(event.target.value) : onChange(null))}
        value={value}
        className={`
          ${title ? "mt-1" : ""}
          block w-full
          px-3 py-2
          transition duration-150 ease-in-out
          border-l border-t border-b border-cool-gray-300
          disabled:bg-gray-100 disabled:text-gray-700 disabled:cursor-not-allowed disabled:shadow-inner
          rounded shadow-sm form-input
          ${error ? "ring outline-none border-red-200 ring-opacity-50 ring-red-200" : ""}
          focus:outline-none focus:ring focus:ring-opacity-50 focus:ring-blue-200 focus:border-blue-300
          text-sm leading-5
          ${className}`}
        autoFocus={autoFocus}
      />
    </>
  );
}
